import React, { FunctionComponent } from 'react';

import { StyledContainer, StyledSpinner } from './spinner.styled';

export const Spinner: FunctionComponent = () => (
  <StyledContainer>
    <StyledSpinner />
  </StyledContainer>
);
